var map = {
	"./01_TP71375264.webp": 1751,
	"./02_TP99655661.webp": 7578,
	"./03_TP84560502.webp": 3104,
	"./04_TP56496721.webp": 1739,
	"./05_TP98353860.webp": 2332,
	"./06_TP74028044.webp": 2342
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7379;